import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative bg-gradient-to-b from-navy to-navy-dark text-white pt-16 pb-20 px-4 overflow-hidden" data-id="element-68">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-69">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold leading-tight mb-6 text-white" data-id="element-70">
          Deja de ser "invisible" para el sistema: Construye un Crédito de{' '}
          <span className="text-gold" data-id="element-71">700+ Puntos</span> en USA aunque no tengas
          Seguro Social
        </h1>

        <h2 className="text-lg md:text-xl font-body font-normal text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-72">
          El método exacto para mujeres latinas que quieren rentar su propia
          casa, comprar un auto con bajo interés y dejar de vivir atrapadas en
          el efectivo.
        </h2>

        <div className="flex justify-center mb-10" data-id="element-73">
          <img src="https://cdn.magicpatterns.com/uploads/ai6mtRG7Qpzd348Xhqh7To/heylloyd-image-metodo_700.png" alt="Crédito USA: Método 700+ Guía Digital" className="w-full max-w-lg object-contain drop-shadow-2xl" data-id="element-74" />
        </div>

        <div className="max-w-xl mx-auto" data-id="element-75">
          <CTAButton animate={true} data-id="element-76" />
        </div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10 pointer-events-none" data-id="element-77">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-gold blur-[120px]" data-id="element-78"></div>
        <div className="absolute top-[60%] -right-[10%] w-[40%] h-[40%] rounded-full bg-gold blur-[100px]" data-id="element-79"></div>
      </div>
    </section>;
}